export default import.meta.ROLLUP_FILE_URL_tgItkVM6JTrfm2CiQnzY5g;